import { E } from '@angular/cdk/keycodes';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SequenceActivityGroupByReportService {

  url2 = environment.serverAPI9 + "/api/sequenceActivity";

  constructor(private http: HttpClient) { }


  searchSequenceActivity(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
       "groupBy": groupBy,

      additionalQuery: additionalQuery != null ? additionalQuery : null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition${queryParams}`, requestBody);
  }


}
